export default "__VITE_ASSET__CtOk1xdc__"